import React, {useEffect, useState} from 'react'
import styled from '@emotion/styled'
import ProductItem from '../ProductItem';
import _ from "lodash";
import {Link,useHistory} from 'react-router-dom';
import SearchBar from '../Products/SearchBar';
import {getCatalogue,getCategories} from "../../network";
import SearchResults from '../Products/SearchResults';

const FeaturedWrapper = styled.div`
    width:auto;
    @media only screen and (max-width: 1100px) {
        width: 60rem;
    }

`;
const FeaturedContainer = styled.div`
    display: grid;
    grid-auto-flow:row;
    margin-top:10rem;
    grid-row-start: 2;


    background: none;

    align-items: center;
    justify-items: center;
    width: auto;

    @media only screen and (max-width: 500px) {
       justify-items: normal;
    }
    
`;

const ExploreContainer = styled.div`
    position:relative;
    left:0.2rem;
    display: flex;
    flex-direction: row;
    width:96%;
    justify-content: space-between;
    align-self: end;
    margin-bottom:1rem;
    .explore{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 2.5rem;
        line-height: 2.75rem;
        /* identical to box height, or 110% */
    
    
        /* default/gray/700 */
    
        color:var(--color-gray-700);
    }
    .view--all{
        color: var(--company-dark);
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 1rem;
        margin-top:2rem;
        grid-column-start: 3;
        justify-self: right;
        cursor: pointer;
        
    }
    @media (max-width: 768px){
        
        .explore{
            position: relative;
            font-size:var(--font-36);
        }
     }
    @media (max-width: 500px){
        .view--all{
            display: none;
        }
       .explore{
           width:40%;
           font-size: var(--space-24);
       }
    }

`;

const SearchBarContainer = styled.div`
    position:relative;
    width:100%;
    .cardGradient{
        position:absolute;
        right: -1rem;
        width: var(--space-48);
        height: 30rem;
        top: 9.1rem;
        z-index:2;
        background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    }
    .cardGradient--second{
        position:absolute;
        width: var(--space-48);
        height: 30rem;
        left: -2rem;
        top: 9.1rem;
        z-index:2;
        background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    }
    @media only screen and (max-width: 768px) {
       width:70%;
       
    }
    @media only screen and (max-width: 500px) {
    
        width: 90vw;
     }
   
`;
const Results = styled.div`
    position:relative;
    margin-top:4rem;
    display:grid;
    z-index:1;
    grid-auto-flow:column;
    grid-gap:3rem;
    width:auto;
    overflow-y:hidden;
    overflow-x:scroll;
    padding-bottom:4rem;
    

 

    /* width */
    &::-webkit-scrollbar {
        width: var(--space-6) !important; 
        height:var(--space-6);
    }

    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 var(--space-6) var(--color-gray-900);
        border-radius: var(--space-6);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #02B2D9;
        border-radius: var(--space-6);
    }
    @media only screen and (max-width: 500px) {
        /* width: 60%; */
    }
`;

function Featured(props) {
 
    const history = useHistory();
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [brandId, setBrandId] = useState('');
    const [brandName, setBrandName] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(12);
   // const [pageCount, setPageCount] = useState(1);
    // const [totalResultsCount, setTotalResultsCount] = useState(0);
    // const [currentResultsCount, setCurrentResultsCount] = useState(0);

    useEffect(() => {
        const retrieveCategories = async () => {
            const result = await getCategories();
            setCategories([...result]);
        }
       
        retrieveCategories();
       
    }, []);

    useEffect(() => search(searchText, categoryId, brandId), [searchText, categoryId, brandId, currentPage])

    const search = (searchText, category, brand) => {
        getCatalogue(searchText, category, brand, currentPage, pageLimit)
            .then(result => {
                setProducts([...result.data]);
                // setCurrentResultsCount(result.results);
                // setTotalResultsCount(result.total);
                //setPageCount(Math.ceil(result.total / pageLimit));
            })
            .catch(error => console.error(error))
            
    };

    const debouncedSearchText = _.debounce(query => setSearchText(query), 400);

    const onSearchTextChange = e => {
        const value = e.target.value.trim();
        debouncedSearchText(value);
    }

    // const changePage = direction => {
    //     if (currentPage === 1 && direction < 0) return;
    //     if (currentPage === pageCount && direction > 0) return;

    //     setProducts([]);
    //     setCurrentPage(currentPage + (direction));
    // };

    const handleCategoryChange = e => {
        const {value} = e.target;
        searchCategoryId(value);
    };

    const searchCategoryId = value => {
        if (value) {
            const category = categories.find(element => element._id === value);
            setCategoryName(category.name);
        } else setCategoryName(value);
        setCategoryId(value);
    }






        return (
            <FeaturedWrapper>
                
            <FeaturedContainer>
                <ExploreContainer>
                    <span className="explore">{props.heading}</span>
                    <p className="view--all" onClick={()=>history.push("/products")}>{props.text}</p>
                </ExploreContainer>

            </FeaturedContainer>
            <SearchBarContainer>
                <SearchBar
                    value={props.value}
                    search={props.search}
                    categories={categories}
                    selectedCategory={categoryId}
                    categoryChange={handleCategoryChange}
                    onSearchTextChange={onSearchTextChange}
                />
            
                    <Results>
                        {
                            products.map((product, index) => <ProductItem
                                    
                                    setItem={props.setItem}
                                    setDisplay={props.setDisplay}
                                    key={index}
                                    product={product}
                                    onClick={() => console.log(product.id)}
                                />
                            )
                        }
                        
                    </Results>
                    {/* <div className="cardGradient"></div>  
                    <div className="cardGradient--second"></div>   */}
                </SearchBarContainer>
             </FeaturedWrapper>
        );

}

export default Featured;
